/* Zeno — Recently Viewed Products
   ----------------------------------
   Two jobs, both client-side (Liquid has no access to localStorage):

   1. TRACKING (runs on every product page): reads
      window.ZenoCurrentProduct.handle (set inline in
      sections/main-product.liquid) and pushes it to the front of a
      localStorage list, deduped, capped at 12 entries.

   2. RENDERING (runs wherever [data-zeno-recently-viewed] exists,
      i.e. sections/recently-viewed-products.liquid): reads that same
      list, excludes the product currently being viewed (if any),
      fetches each product's live data via Shopify's /products/{handle}.js
      endpoint, and renders simple cards into a horizontal-scroll
      carousel (.zeno-carousel, shared with "You may also like"). If
      the list is empty after exclusion, the section stays hidden —
      never shows an empty "Recently Viewed" heading with nothing
      under it. */

(function () {
  var STORAGE_KEY = 'zeno_recently_viewed';
  var MAX_STORED = 12;
  var MAX_SHOWN = 8;

  // Zeno: removes duplicate handles, keeping the FIRST occurrence (most
  // recent view, since handles are unshifted to the front on each
  // visit). Applied on every read/write so any pre-existing duplicate
  // in a visitor's stored history (e.g. from before this fix, or from
  // two tabs writing at once) self-heals rather than needing a manual
  // localStorage clear.
  function dedupe(handles) {
    var seen = {};
    var result = [];
    handles.forEach(function (h) {
      if (!seen[h]) {
        seen[h] = true;
        result.push(h);
      }
    });
    return result;
  }

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? dedupe(parsed) : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(dedupe(handles).slice(0, MAX_STORED)));
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) — fail silently */
    }
  }

  function trackCurrentProduct() {
    var current = window.ZenoCurrentProduct && window.ZenoCurrentProduct.handle;
    if (!current) return;
    var handles = getStored().filter(function (h) {
      return h !== current;
    });
    handles.unshift(current);
    setStored(handles);
  }

  // Zeno: matches the same trailing-".00" strip used everywhere else
  // prices render (see snippets/price.liquid) — this card is built
  // client-side via JS rather than server-rendered Liquid, so it needed
  // its own copy of that behavior; the Liquid-side fix alone never
  // touched this file. Defaults to AUD (the store's actual currency)
  // rather than USD if Shopify.currency isn't available for some
  // reason, so a fallback never shows the wrong currency symbol.
  function formatMoney(cents, currencyCode) {
    try {
      var formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(
        cents / 100
      );
      return formatted.replace('.00', '');
    } catch (e) {
      var plain = (cents / 100).toFixed(2).replace('.00', '');
      return plain;
    }
  }

  function buildCard(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    var price = formatMoney(product.price, (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD');

    var li = document.createElement('li');
    li.className = 'zeno-carousel__item';

    var a = document.createElement('a');
    a.href = product.url;
    a.className = 'zeno-recently-viewed__card';

    var mediaWrap = document.createElement('div');
    mediaWrap.className = 'zeno-recently-viewed__image-wrapper';
    if (image) {
      var img = document.createElement('img');
      img.src = image;
      img.alt = product.title;
      img.loading = 'lazy';
      mediaWrap.appendChild(img);
    }
    a.appendChild(mediaWrap);

    var title = document.createElement('p');
    title.className = 'zeno-recently-viewed__title';
    title.textContent = product.title;
    a.appendChild(title);

    var priceEl = document.createElement('p');
    priceEl.className = 'zeno-recently-viewed__price';
    priceEl.textContent = price;
    a.appendChild(priceEl);

    li.appendChild(a);
    return li;
  }

  function renderInto(root) {
    var current = window.ZenoCurrentProduct && window.ZenoCurrentProduct.handle;
    var handles = getStored()
      .filter(function (h) {
        return h !== current;
      })
      .slice(0, MAX_SHOWN);

    if (handles.length === 0) {
      return; // stays hidden
    }

    var grid = root.querySelector('[data-zeno-recently-viewed-grid]');
    if (!grid) return;

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      if (valid.length === 0) return;

      valid.forEach(function (product) {
        grid.appendChild(buildCard(product));
      });

      root.hidden = false;
    });
  }

  function init() {
    trackCurrentProduct();

    var sections = document.querySelectorAll('[data-zeno-recently-viewed]');
    sections.forEach(renderInto);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
